// ============================================================================
//  CATÀLEG DE PRODUCTES DPNox  —  EDITA AQUEST FITXER PER GESTIONAR ELS ARTICLES
// ============================================================================
//
//  COM AFEGIR UN ARTICLE NOU:
//    1. Copia un bloc { ... } sencer de la llista PRODUCTS.
//    2. Enganxa'l al final i canvia'n els valors ("id" ha de ser únic).
//    3. Guarda i executa:  yarn build
//
//  CAMPS PRINCIPALS:
//    id, category ("dpf" o "catalyst"), ref, oem [], specs [], name{es,ca,en}, desc{es,ca,en}
//
//  FITXA AMPLIADA (opcionals — es mostren en clicar el producte):
//    gallery → llista de fotos extra per a la galeria. Ex: ["/productes/a.jpg", "https://..."]
//              (si no en poses, es fa servir només la foto "image").
//    tech    → fitxa tècnica. Parells clau: valor. Claus admeses (es tradueixen soles):
//              brand, model, euro, diameter, length, weight, material, condition, warranty, delivery
//              Ex:  tech: { brand: "Scania", euro: "Euro 6", diameter: "Ø 320 mm", warranty: "12 meses" }
//
//  FOTOS: URL "https://..."  o fitxer propi dins  frontend/public/productes/  → "/productes/nom.jpg"
// ============================================================================

const HC = "https://images.unsplash.com/photo-1723492289003-218ad9ef67c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const PARTS = "https://images.unsplash.com/photo-1759419281480-bacc913c9606?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const DPFCLOSE = "https://images.unsplash.com/photo-1643151663724-ab51858d5fe1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const WORK = "https://images.pexels.com/photos/7564861/pexels-photo-7564861.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400";

export const CATEGORIES = [
  { id: "dpf", code: "01", key: "dpf" },
  { id: "catalyst", code: "02", key: "catalyst" },
];

export const PRODUCTS = [
 
 {
    id: "0208035011",
    category: "catalyst",
    ref: "020.8035.011",
    oem: ["5801391046", "5802011834", "5801391037", "5801391038", "5802031994", "5802031989"],
    specs: ["Unidad Catalizadora reacondicionada DOC+SCR+DPF Iveco Euro 6"],
    image: "/productes/8035011.png",
    gallery: ["/productes/8035011.png", "/productes/8035011_2.png", "/productes/8035011_3.png"],
    tech: {
      brand: "Iveco",
      model: "Eurocargo Tector 7 4.5L. ",
      euro: "Euro 6",
      material: "DOC + SCR + DPF",
      condition: "Reacondicionado",
      warranty: "12 meses",
    },
    name: {
      es: "Unidad Catalizadora reacondicionada DOC+SCR+DPF Iveco Euro 6",
      ca: "Unitat catalitzadora reacondicionada Doc+SCR+Dpf Iveco euro 6",
      en: "Reconditioned Catalytic Converter Unit DOC+SCR+DPF Iveco Euro 6",
      de: "Aufgearbeitete Katalysatoreinheit DOC+SCR+DPF Iveco Euro 6",
    },
    desc: {
      es: "Unidad de postratamiento de gases de escape reacondicionada con DPF y monolitos nuevos. Iveco Euro 6.",
      ca: "Unitat de postractament de gasos d'escapament reacondicionada amb DPF y monolits nous. Iveco Euro 6.",
      en: "Reconditioned exhaust after-treatment unit with DPF amb new monolith. Iveco Euro 6.",
      de: "Aufgearbeitete Abgasnachbehandlungseinheit mit neuem DPF und neuen Monolithen. Iveco Euro 6.",
    },
  },

  {
    id: "0208754016 ",
    category: "catalyst",
    ref: "020.8754.016",
    oem: ["81151039223", "81515036223", "81151036165", "81151039182", "81151036182"],
    specs: ["Unidad Catalizadora reacondicionada DOC+SCR+DPF Man Euro 6"],
    image: "/productes/8754016.jpg",
    gallery: ["/productes/8754016.jpg", "/productes/8754016_2.png", "/productes/8754016_3.png"],
    tech: {
      brand: "Man",
      model: "TGX y TGS 2.021 ",
      euro: "Euro 6",
      material: "DOC + SCR + DPF",
      condition: "Reacondicionado",
      warranty: "12 meses",
    },
    name: {
      es: "Unidad Catalizadora reacondicionada DOC+SCR+DPF Man Euro 6",
      ca: "Unitat catalitzadora reacondicionada Doc+SCR+Dpf Man euro 6",
      en: "Reconditioned Catalytic Converter Unit DOC+SCR+DPF Man Euro 6",
      de: "Aufgearbeitete Katalysatoreinheit DOC+SCR+DPF Man Euro 6",
    },
    desc: {
      es: "Unidad de postratamiento de gases de escape reacondicionada con DPF y monolitos nuevos. Man TGX/TGS Euro 6.",
      ca: "Unitat de postractament de gasos d'escapament reacondicionada amb DPF y monolits nous. Man TGX/TGS Euro 6.",
      en: "Reconditioned exhaust after-treatment unit with DPF amb new monolith. Man TGX/TGS Euro 6.",
      de: "Aufgearbeitete Abgasnachbehandlungseinheit mit neuem DPF und neuen Monolithen. Man TGX/TGS Euro 6.",
    },
  },

 {
    id: "0208010017 ",
    category: "catalyst",
    ref: "020.8010.017",
    oem: ["2483455", "2248584", "2164453", "2248583",],
    specs: ["Unidad Catalizadora reacondicionada DOC+SCR+DPF Scania Euro 6"],
    image: "/productes/8010017_2.png",
    gallery: ["/productes/8010017_2.png", "/productes/8010017.png", "/productes/8010017_3.png", "/productes/8010017_4.png"],
    tech: {
      brand: "Scania",
      model: "P/G/R 2.014 ",
      euro: "Euro 6",
      material: "DOC + SCR + DPF",
      condition: "Reacondicionado",
      warranty: "12 meses",
    },
    name: {
      es: "Unidad Catalizadora reacondicionada DOC+SCR+DPF Scania Euro 6",
      ca: "Unitat catalitzadora reacondicionada Doc+SCR+Dpf Scania euro 6",
      en: "Reconditioned Catalytic Converter Unit DOC+SCR+DPF Scania Euro 6",
      de: "Aufgearbeitete Katalysatoreinheit DOC+SCR+DPF Scania Euro 6",
    },
    desc: {
      es: "Unidad de postratamiento de gases de escape reacondicionada con DPF y monolitos nuevos. Scania P/G/R Euro 6.",
      ca: "Unitat de postractament de gasos d'escapament reacondicionada amb DPF y monolits nous. Scania P/G/R Euro 6.",
      en: "Reconditioned exhaust after-treatment unit with DPF amb new monolith. Scania P/G/R Euro 6.",
      de: "Aufgearbeitete Abgasnachbehandlungseinheit mit neuem DPF und neuen Monolithen. Scania P/G/R Euro 6.",
    },
  },

{
    id: "0208001019",
    category: "catalyst",
    ref: "020.8001.019",
    oem: ["21478417", "7421477417", "7421478417", "21477417",],
    specs: ["Unidad Catalizadora reacondicionada DOC+SCR+DPF Renault/Volvo Euro 6"],
    image: "/productes/8001019_1.png",
    gallery: ["/productes/8001019_1.png", "/productes/8001019_2.png", "/productes/8001019.png"],
    tech: {
      brand: "Renault/Volvo",
      model: "T series ",
      euro: "Euro 6",
      material: "DOC + SCR + DPF",
      condition: "Reacondicionado",
      warranty: "12 meses",
    },
    name: {
      es: "Unidad Catalizadora reacondicionada DOC+SCR+DPF Renault/Volvo Euro 6",
      ca: "Unitat catalitzadora reacondicionada Doc+SCR+Dpf Renault/Volvo euro 6",
      en: "Reconditioned Catalytic Converter Unit DOC+SCR+DPF Renault/Volvo Euro 6",
      de: "Aufgearbeitete Katalysatoreinheit DOC+SCR+DPF Renault/Volvo Euro 6",
    },
    desc: {
      es: "Unidad de postratamiento de gases de escape reacondicionada con DPF y monolitos nuevos. Renault / Volvo Euro 6.",
      ca: "Unitat de postractament de gasos d'escapament reacondicionada amb DPF y monolits nous. Renault / Volvo Euro 6.",
      en: "Reconditioned exhaust after-treatment unit with DPF amb new monolith. Renault / Volvo Euro 6.",
      de: "Aufgearbeitete Abgasnachbehandlungseinheit mit neuem DPF und neuen Monolithen. Renault/Volvo Euro 6.",
    },
  },


  {
    id: "0208068001",
    category: "catalyst",
    ref: "020.8068.001",
    oem: ["A0054903112", "A0094908812", "A0064908712", "A0074905812", "A0074908212"],
    specs: ["UD. POSTRAT. GASES ESCAPE REACONDICIONADO CON DPF MERCEDES EURO6"],
    image: "/productes/8068001.png",
    gallery: ["/productes/8068001.png", "/productes/8068001_2.png", "/productes/8068001_3.png"],
    tech: {
      brand: "Mercedes-Benz",
      model: "Actros / Antos / Arocs",
      euro: "Euro 6",
      material: "DOC + SCR + DPF",
      condition: "Reacondicionado",
      warranty: "12 meses",
    },
    name: {
      es: "Unidad Catalizadora reacondicionada DOC+SCR+DPF Mercedes Euro 6",
      ca: "Unitat catalitzadora reacondicionada Doc+SCR+Dpf Mercedes euro 6",
      en: "Reconditioned Catalytic Converter Unit DOC+SCR+DPF Mercedes Euro 6",
      de: "Aufgearbeitete Katalysatoreinheit DOC+SCR+DPF Mercedes Euro 6",
    },
    desc: {
      es: "Unidad de postratamiento de gases de escape reacondicionada con DPF y monolitos nuevos. Mercedes Arocs / Antos / Actros Euro 6.",
      ca: "Unitat de postractament de gasos d'escapament reacondicionada amb DPF i monolits nous. Mercedes Arocs / Antos / Actros Euro 6.",
      en: "Reconditioned exhaust after-treatment unit with DPF and new monolith. Mercedes Arocs / Antos / Actros Euro 6.",
      de: "Aufgearbeitete Abgasnachbehandlungseinheit mit neuem DPF und neuen Monolithen. Mercedes Arocs / Antos / Actros Euro 6.",
    },
  },
   {
    id: "fapEU6",
    category: "dpf",
    ref: "DPF-E6-SC", 
    oem: ["5802848206", "2KI035-RX", "5803195113", "5802205422", "2K032-RX", "5802039934", "2KI016-RX", "5802041648", "500060520", "5802041633", "2KI019-RX", "5802041542", "7421750157", "8AI001-RX", "7421794709", "7423138863", "7485013250", "21794709", "85022127", "85022222", "85020453", "85013698", "21750157", "21922979", "23037748", "7421922964", "7485013517", "21716417","8AI004-RX","21716419","7421716419","7421716417","85013297","5801651186","2KI000-RX","500060516","5802206101","14903792","5AI015-RX","1490369280","A0014903692","A0004906492","A000490649280","A001490369280","A000490659280","A002490459280","A002490449280","2446964","6LI001-RX","2137598","2222655","570758","570808","1961522","2AI003-RX","1961522R","5296249","2274555","2137443","574223","36.15103-6018","4II005","36.15103-9018","36151039018","36151036018","51.15103-4029","31.70.5196.2.00","31705196200","14906592","5AI017-RX","1490659280","490629280","14906992","1490699280","24909392","2490939280","A0004906292","A0014906592","A0014906992","A0024909392","81151030111","4II002-RX","81151030112","81151030124","81151030113","4II003-RX","81151039113","81151030123","81151039123","A0024909692","50520202","A0004908892","200027139687","24905692","5AI021","34900092","34900392","A0024905692","A0034900092","A0034900392","2192100","2AI005","2144435","2326074","2326074R","2KI015-RX","A001490299280","5AI004-RX","A001490389280","1490389280","1490299280","5801651208","14906492","5AI010-RX","1490649280","A0014906992","14906892","A0014906892","A0014906492","5801651207","2KI014-RX","A002490429280","5AI012-RX","A002490289280","A000490549280","A0024904292","5802039922","2KI025-RX","A001490739280","5AI013-RX","A001490629280","1490739280","5802020369","2KI020-RX","5802045132","A002490369280","5AI022-RX","A001490279280","A000490469280","5802020368","2KI017-RX","5802045133","1490489280","5AI009-RX","1490859280","A0014905392","1490539280","A002490322280","A001490859280","A001490539280","A001490489280","A001490329280","490589280","5AI007-RX","1490289280","4905892","2490399280","A0004905892","A001490289280","2490379280","A000490589280","A002490379280","1891485","2AI000-RX","1945456","2137441R","2137441","5802039924","2KI024-RX","5802039929","5802041639","14905292","5AI005-RX","1490529280","1490549280","14906392","1490639280","14907092","1490709280","1490839280","1490849280","1490869280","1490939280","2490389280","A0014906392","A001490939280","A001490839280","A0014908692","81151039168","4II018-RX","81151030164","81151030175","5801651189","2KI010","5801651188","5802205423","14907592","5AI003-RX","1490759280","14906692","1490669280","24909292","2490929280","A0014906692","A001490669280","A0014907592","A001490759280","A0024909292","A002490929280","21716414","8AI002-RX","21716416","23108407","23135528","7421716414","7421716416","7423135543","22936980","1997433","1JI001-RX","1997433R","2137442","2137442R","5296897","6625692","1997443R","1997443","2097594","6LI000-rx","2179961","2269640","2575576","570759","570768","2004103","2141164","217996","2494028","2494029","2503085","2503087","570757","570761","570762","81151030107","4II001-RX","81151030128","81151039107","81151039130","5801651187","2KI002-RX","14903092","5AI001-RX","1490309280","A0014903092","A001490309280","24904192","2490419280","A0024904192","A002490419280","6li000","226940","82207908", "358518", "3585189"],
    specs: ["Euro 6", "Regeneración", "Con juntas"],
    image: "/productes/FapEu6_DPNox.png",
    gallery: ["/productes/FapEu6_DPNox.png", "/productes/transporte.png", ],
    tech: {
      brand: "",
      model: "",
      euro: "Euro 6",
      diameter: "",
      material: "Cordierita / SiC",
      condition: "Reacondicionado, con kit de juntas.",
      warranty: "12 meses",
    },
    name: {
      es: "Regeneración de filtros de partículas DPF Euro 6",
      ca: "Regeneració de filtres de partícules DPF Euro 6 ",
      en: "DPF Particulate Filter regeneration service Euro 6 ",
      de: "Regeneration von Euro-6-Partikelfiltern (DPF)",
    },
    desc: {
      es: "Consúltenos sobre nuestro servicio de regeneración de filtros de partículas con kit de sellado nuevo.",
      ca: "Consulteu-nos sobre el nostre servei de regeneració de filtres de partícules amb kit de segellat nou.",
      en: "Ask us about our particulate filter regeneration service with a new sealing kit.",
      de:"Fragen Sie uns nach unserem Service zur Regeneration von Partikelfiltern inklusive neuem Dichtungssatz.",
    },
  },
];
